import { API } from '@apis/endPoints';
import { axiosService, checkError } from '@services';

export default async function getPvPower(plant_id) {
  if(!plant_id) {
    throw new Error('Plant ID is required');
  }

  const res = await axiosService({
    method: 'post',
    data: {
      path: `/measurements/sets/EnergyBalance/Recent`,
      plant_id: plant_id,
    },
    apiPath: `${API.PLANT_MANAGEMENT}`,
  });
  const data = res?.data?.result;

  if (res?.codeHTTP === 200) {
    return data;
  } else {
    return checkError(res, getPvPower, plant_id);
  }
}

// const apiPvPower = async () => {
//   const res = await axiosService({
//     method: 'post',
//     params: {
//       path: `/measurements/sets/EnergyBalance/Recent`,
//       // eslint-disable-next-line camelcase
//       plant_id: id,
//     },
//     apiPath: `${API.PLANT_MANAGEMENT}`,
//   });
//   const data = res?.data?.result;

//   if (res?.codeHTTP === 200) {
//     setPvPower(data.set[0].pvGeneration);
//   } else {
//     await checkError(res, apiPvPower);
//   }
// };
